import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import {DataStorageService} from '../../shared/services/data-storage.service';
import {UploadService} from '../../shared/services/upload.service';
import {Upload} from 'src/app/shared/models/upload.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'form-pic-page',
    templateUrl: 'form-pic-page.html'
})

export class FormPicPageComponent implements OnInit, OnDestroy {

    @Input() description: string;
    @Input() uploads: Upload[];
    @Input() size: string;
    uploads_new: Upload[] = [];

    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(private dataStorageService: DataStorageService, private uploadService: UploadService) {
    }

    ngOnInit() {
        console.log(this.uploads);
        this.uploadService.uploadSub.pipe(takeUntil(this.unsubscribe$)).subscribe(
            upload => {
                this.uploads_new.push(upload);
            }
        );
    }

    onUpload() {
        this.uploadService.uploadProcessEmitter.emit({'type': 'description', 'description': this.description, id: 0});
    }

    onDeleteUpload(id: number, name: string) {
        this.dataStorageService.deleteUpload(id, name).pipe(takeUntil(this.unsubscribe$)).subscribe(
            responseData => {
                if (responseData['status'] === '200') {
                    console.log(responseData);
                    let index = 0;
                    if (this.uploads.findIndex(upload => upload.id === id) !== null) {
                        index = this.uploads.findIndex(upload => upload.id === id);
                        this.uploads.splice(index, 1);
                    } else {
                        index = this.uploads_new.findIndex(upload => upload.id === id);
                        this.uploads_new.splice(index, 1);
                    }
                } else if (responseData['status'] === '405' && responseData['error'] === 'No such file or directory') {
                    this.dataStorageService.deleteUploadRow(id, name).pipe(takeUntil(this.unsubscribe$)).subscribe(
                        () => {
                            location.reload();
                        }
                    );
                }
            }
        );
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
